module.exports = __webpack_public_path__ + "img/dog2.04bfe2a4.jpg";